const state = {
    produceInformationHeatFields: [
        {
            key: "item_title",
            label: "",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "work_dispatch_weight",
            label: "工單重量(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "work_total_weight",
            label: "輾牙完工重量(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "work_in_weight",
            label: "熱處理入料重量(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "quench_furn_time",
            label: "淬火入料時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "tempering_furn_time",
            label: "回火入料時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    produceInformationHeatItem: [
        // {
        //     "item_title": "實際",
        //     "qty": { name: "計數器支數", count: 130190 },
        //     "unit_weight": "4.65",
        //     "standard_total_weight": "-",
        //     "unit_material_weight": "-",
        //     "material_total_weight": "-",
        // },
        // {
        //     "item_title": "標準",
        //     "qty": { name: "派工支數", count: 361600 },
        //     "unit_weight": "4.65",
        //     "standard_total_weight": "1681.44",
        //     "unit_material_weight": "4.7",
        //     "material_total_weight": "1699.52",
        // }
    ],
}
const getters = {
    get_produceInformationHeatFields: state => {
        return state.produceInformationHeatFields
    },
    get_produceInformationHeatItem: state => {
        return state.produceInformationHeatItem
    },
}
const actions = {
    set_produceInformationHeatFields(context, array) {
        context.commit('SET_PRODUCEINFORMATIONHEATFIELDS', array);
    },
    set_produceInformationHeatItem(context, array) {
        context.commit('SET_PRODUCEINFORMATIONHEATITEM', array);
    },
}
const mutations = {
    SET_PRODUCEINFORMATIONHEATFIELDS(state, array) {
        state.produceInformationHeatFields = array;
    },
    SET_PRODUCEINFORMATIONHEATITEM(state, array) {
        state.produceInformationHeatItem = array;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/produceInformationHeat.js